import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';
import { GET_COACHING_TOKEN_MUTATION } from './getCoachingTokenMutation';
import {
  COACHING_TOKEN_ERROR_CODES,
  CoachingTokenError,
  normalizeCoachingTokenError,
} from './coachingTokenError';

const MODULE_ROUTE = 'modules/integrations/coachSSO';

// Requests a fresh Coaching SSO token from general v2.
// Resolves with the token string; rejects with a CoachingTokenError.
export const fetchCoachingToken = async () => {
  try {
    const data = await clientMutation(GET_COACHING_TOKEN_MUTATION, {}, endpoints.GRAPHQL_GENERAL_V2);
    const token = data?.getCoachingToken;

    if (!token) {
      throw new CoachingTokenError(COACHING_TOKEN_ERROR_CODES.EMPTY_TOKEN);
    }

    return token;
  } catch (err) {
    ExceptionManager(err, MODULE_ROUTE, 'fetchCoachingToken');
    throw normalizeCoachingTokenError(err);
  }
};
